"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentsContainer = void 0;
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _components = require("../components");
var _contexts = require("../contexts");
var _jsxRuntime = require("react/jsx-runtime");
const ContentsContainer = ({
  children
}) => {
  const {
    tenant
  } = (0, _contexts.useConfiguration)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    data: contentsData
  } = (0, _staticApiClientReact.useGetTenantApplicationsCheckoutRegistrationContent)(tenant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ContentsProvider, {
      value: contentsData?.contents[contentsData.defaultLanguage ?? language] ?? {},
      children: children
    })
  });
};
exports.ContentsContainer = ContentsContainer;
//# sourceMappingURL=ContentsContainer.js.map